import sanitizeHtml from 'sanitize-html';

function sanitizeHtmlInline(html) {
    return sanitizeHtml(html, {
        allowedTags: [
            'a', 'b', 'i', 'strong', 'em', 'br',
        ]
    });
}

function sanitizeHtmlParagraph(html) {
    return sanitizeHtml(html, {
        allowedTags: [
            'a', 'b', 'i', 'strong', 'em', 'br', 'p', 'ul', 'ol', 'li',
            'table', 'tbody', 'thead', 'tfoot', 'tr', 'td', 'th',
        ]
    });
}

export {
    sanitizeHtmlInline,
    sanitizeHtmlParagraph
}
